import { Skeleton } from '@/_config/lib/react-native-skeleton';
import styles from './delivery-modal-skeleton.module.scss';

export const DeliveryModalSkeleton = () => {
  return (
    <div className={styles.container}>
      <div className={styles.statusSection}>
        <Skeleton height={24} width={150} borderRadius={8} />
        <Skeleton height={20} width={200} borderRadius={8} />
      </div>

      <div className={styles.informationGrid}>
        <div className={styles.infoBox}>
          <Skeleton height={20} width={180} borderRadius={8} />
          <div className={styles.infoRows}>
            <Skeleton height={16} width="100%" borderRadius={6} />
            <Skeleton height={16} width="100%" borderRadius={6} />
            <Skeleton height={16} width="90%" borderRadius={6} />
            <Skeleton height={16} width="100%" borderRadius={6} />
            <Skeleton height={16} width="85%" borderRadius={6} />
            <Skeleton height={16} width="100%" borderRadius={6} />
            <Skeleton height={16} width="95%" borderRadius={6} />
          </div>
        </div>

        <div className={styles.infoBox}>
          <Skeleton height={20} width={180} borderRadius={8} />
          <div className={styles.infoRows}>
            <Skeleton height={16} width="100%" borderRadius={6} />
            <Skeleton height={16} width="100%" borderRadius={6} />
            <Skeleton height={16} width="90%" borderRadius={6} />
            <Skeleton height={16} width="100%" borderRadius={6} />
            <Skeleton height={16} width="85%" borderRadius={6} />
            <Skeleton height={16} width="100%" borderRadius={6} />
            <Skeleton height={16} width="95%" borderRadius={6} />
          </div>
        </div>
      </div>

      <div className={styles.activitySection}>
        <Skeleton height={20} width={180} borderRadius={8} />
        <div className={styles.activityRows}>
          <Skeleton height={16} width="100%" borderRadius={6} />
          <Skeleton height={16} width="95%" borderRadius={6} />
          <Skeleton height={16} width="90%" borderRadius={6} />
          <Skeleton height={16} width="100%" borderRadius={6} />
        </div>
      </div>
    </div>
  );
};
